import {PermissionType} from '@hconnect/apiclient'
import {PlantSelect} from '@hconnect/common/components'
import {PlantSelectOption} from '@hconnect/common/hproduce/types'
import {PageContainer} from '@hconnect/uikit/src/lib2'
import {useUpmPlantsContext, getPlantName} from '@hconnect/upm'
import {FC} from 'react'
import {generatePath, Navigate} from 'react-router'

import {useTranslationPrefix, usePlantsByPermission} from '../../../shared/hooks'

type PerformancePlantSelectProps = {
  path: string
  permission: PermissionType
}

export const PlantSelectByPermission: FC<PerformancePlantSelectProps> = ({path, permission}) => {
  const {hrocPrefix} = useTranslationPrefix()
  const {plantIds} = usePlantsByPermission(permission)
  const upmPlants = useUpmPlantsContext()

  const plantOptions: PlantSelectOption[] = plantIds.map((plantId) => {
    return {
      plantId,
      plantName: getPlantName(upmPlants, plantId),
      url: generatePath(path, {plantId})
    }
  })

  if (plantOptions.length === 1) {
    return <Navigate to={plantOptions[0].url} />
  }

  return (
    <PageContainer>
      <PlantSelect plants={plantOptions} translationPrefix={hrocPrefix} />
    </PageContainer>
  )
}
